import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { supabase } from "../../lib/supabase";
import { invalidateSharingQueries } from "../../lib/invalidateSharing";
import { ListMember } from "../../types";

// Unlike most mutations here, the error shown to the person is the
// database's own message, not a generic "try again" — invite_list_member()
// raises the exact refusal text this feature calls for (no account at that
// address, already a Member, already invited, your own address, or the
// rate limit), and inventing different copy in the client would just be a
// second, possibly-inconsistent translation of the same rule. The caller
// reads `error.message` from the rejected mutation directly.
export function useInviteListMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      listId,
      email,
    }: {
      listId: string;
      email: string;
    }): Promise<ListMember> => {
      const { data, error } = await supabase.rpc("invite_list_member", {
        p_list_id: listId,
        p_email: email,
      });
      if (error) throw error;
      return data as ListMember;
    },

    onSuccess: (_result, { listId }) => {
      invalidateSharingQueries(queryClient, listId);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useInviteListMember" } });
    },
  });
}
